import { configureStore, combineReducers } from '@reduxjs/toolkit';

import dbReducer from "./dbSlice"

const rootReducer = combineReducers({
  
  db: dbReducer,
})

export const store = configureStore({
  reducer: rootReducer
});
